export default "__VITE_ASSET__CJhyZXS5__"